import React from 'react';
import PropTypes from 'prop-types';
import BootstrapCard from "shared/components/bootstrapCard/BootstrapCard";
import ImportProfileGrid from './comp/importProfileGrid/ImportProfileGridConnector';
import SovosSlidingPanel from 's1-ui/sovos-sliding-panel/SovosSlidingPanel';
import ImportHistoryGrid from './comp/importHistoryGrid/ImportHistoryGridConnector';
import SovosSlidingPanelHeaderActionButtons
  from 's1-ui/sovos-sliding-panel/components/SovosSlidingPanelHeaderActionButtons';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import SovosSlidingPanelHeader from 's1-ui/sovos-sliding-panel/components/SovosSlidingPanelHeader';

class SelectImportProfilePanel extends React.Component {
  state = {
    importHistoryOpen: false
  };

  componentDidMount() {
    this.props.importHistoryActions.fetchImportHistoryStatuses();
  }

  handleOpenImportHistory = () => this.setState({ importHistoryOpen: true });

  handleCloseImportHistory = () => this.setState({ importHistoryOpen: false });

  handlePageChange = (page, perPage) => this.props.importHistoryActions.fetchImportHistory(page, perPage);

  render() {
    const { onProfileSelect, selectedProfileRow, fetchingProfilesList } = this.props;
    return (
      <span>
        <BootstrapCard 
          title="1. Select Import Profile" 
          loading={ fetchingProfilesList } 
          minWidth={ 900 } 
          titleButtons={ [{ label: 'Review Import History', onClick: this.handleOpenImportHistory }] }
          margin={ '15px 0' }
        >
          <ImportProfileGrid onProfileSelect={ onProfileSelect } selectedProfileRow={ selectedProfileRow } showMoreOptions={ true } />
        </BootstrapCard>
        <SovosSlidingPanel
          open={ this.state.importHistoryOpen }
          onClose={ this.handleCloseImportHistory }
          baseWidth={ '1080px' }
        >
          <SovosSlidingPanelHeader title={ 'Import History' }>
            <SovosSlidingPanelHeaderActionButtons>
              <SovosRaisedButton key="close-history" onClick={ this.handleCloseImportHistory }>CLOSE</SovosRaisedButton>
            </SovosSlidingPanelHeaderActionButtons>
          </SovosSlidingPanelHeader>
          <ImportHistoryGrid showMoreOptions={ true } showPagination={ true } onPageChange={ this.handlePageChange } />
        </SovosSlidingPanel>
      </span>
    );
  }
}

SelectImportProfilePanel.propTypes = {
  onProfileSelect: PropTypes.func,
  selectedProfileRow: PropTypes.number,
  fetchingProfilesList: PropTypes.bool,
  importHistoryActions: PropTypes.shape({
    fetchImportHistoryStatuses: PropTypes.func,
    fetchImportHistory: PropTypes.func
  }).isRequired
};

SelectImportProfilePanel.defaultProps = {
  onProfileSelect: () => null,
  selectedProfileRow: -1,
  fetchingProfilesList: false
};

export default SelectImportProfilePanel;



// WEBPACK FOOTER //
// ./src/components/importData/comp/selectImportProfilePanel/SelectImportProfilePanel.js